import { render, staticRenderFns } from "./UserConfiguration.vue?vue&type=template&id=53300a7c"
import script from "./UserConfiguration.vue?vue&type=script&lang=js"
export * from "./UserConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwitchCell: require('/usr/src/app/components/table/cells/SwitchCell.vue').default,PasswordField: require('/usr/src/app/components/form/PasswordField.vue').default,Spinner: require('/usr/src/app/components/includes/Spinner.vue').default})
